/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { faDivide } from '@fortawesome/free-solid-svg-icons'
import React, { useState, useRef } from 'react'
import { setTimeout } from 'timers'
import './Accordion.scss'
import { icon } from '@fortawesome/fontawesome-svg-core'
import AngleArrowDown from '../../../img/angle-arrow-down.png'
import { UserEventLogger } from '../../../utils/UserEventLogger'

export interface IAccordionState {
	active: any
	height: any
	rotate: any
}

export class Accordion extends React.Component<any, IAccordionState> {
	myRef: React.RefObject<any>
	myProductRef: React.RefObject<any>

	constructor(props: any) {
		super(props)

		this.state = {
			active: '',
			height: '0px',
			rotate: 'accordion__icon',
		}
		this.myRef = React.createRef()
		this.myProductRef = React.createRef()
	}

	toggleAccordion(event: any, title: string, productCode: string, productName: string, defaultLoading: boolean) {
		const accordion = jQuery(event.target)

		jQuery('.accordion.active').each((item, index) => {
			const accordionActive = jQuery('.accordion.active')
			accordionActive.removeClass('active')
			jQuery(accordionActive)
				.closest('.accordion__section')
				.find('.accordion__content')
				.css({ maxHeight: '0px' })
			jQuery('.capIcon', accordionActive)
				.removeClass('accordion__icon rotate')
				.addClass('accordion__icon rotateUp')
		})
		if (jQuery(event.target).hasClass('active')) {
			accordion.closest('button').removeClass('active')
			jQuery(accordion)
				.closest('.accordion__section')
				.find('.accordion__content')
				.css({ maxHeight: '0px' })
			jQuery('.capIcon', accordion)
				.removeClass('accordion__icon rotate')
				.addClass('accordion__icon rotateUp')
		} else {
			accordion.closest('button').addClass('active')
			// accordion.css({ "height": "0px" })
			// jQuery(this.myRef.current).css({ "maxHeight": "0px" })
			jQuery(accordion)
				.closest('.accordion__section')
				.find('.accordion__content')
				.css({ maxHeight: `${this.myRef.current.scrollHeight}px` })
			jQuery('.capIcon', accordion)
				.removeClass('accordion__icon rotateUp')
				.addClass('accordion__icon rotate')
		}
		if (!defaultLoading) {
			this.props.loadProductInformation(productCode, productName)
			UserEventLogger.handleUserClickEvent(event, 'SupportSite - Product/Section Page Accordion Section Click', '')
		}
	}

	render() {
		if (this.props.defaultProduct === this.props.productCode) {
			setTimeout(() => {
				this.toggleAccordion({ target: this.myProductRef.current }, this.props.defaultProduct, this.props.defaultProduct, this.props.title, true)
			}, 500)
		}
		return (
			<div>
				<div className="accordion__section">
					<button ref={this.myProductRef} className="accordion" onClick={e => this.toggleAccordion(e, this.props.title, this.props.productCode, this.props.title, false)}>
						{this.props.title}
						<img className="capIcon accordion__icon rotateUp" src={AngleArrowDown} />
					</button>
					<div ref={this.myRef} style={{ maxHeight: '0px' }} className="accordion__content">
						<div className="list-group">{this.props.content}</div>
					</div>
				</div>
			</div>
		)
	}
}
